<script>
    import { onMount } from 'svelte'
    import { fade, fly } from 'svelte/transition'
    import axios from 'axios'

    var thread = null

    onMount (() => {
        thread = setInterval (() => {
            axios.get ('/api/maintenance/status').then (result => {
                if (result.data.maintenance === false) {
                    clearInterval (thread);
                    window.location.reload (true);
                }
            })
        }, 10000)
    })
</script>

<style>
    .Maintenance {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 30;
        background-color: #475b6d;
    }
    .Maintenance .content {
        position: absolute;
        width: 400px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        text-align: center;
    }
</style>

<div class="Maintenance" transition:fly={{ x: -60, duration: 250 }}>
    <div class="content" >
        <div class="heading">Manutenzione</div>
        <div class="text">La webapp non è al momento disponibile a causa di un intervento di manutenzione. </div>
    </div>
</div>